import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class NotasFiscaisEnderecosService extends BaseService {

  constructor(private http: HttpClient) { super(); }

  getPaginado(pagina: number, nome: string) {
    return this.http
      .get(this.UrlService + "NotasFiscaisEnderecos/GetPaginado?pageIndex=" + pagina + "&search=" + encodeURIComponent(nome))
      .pipe(map((res: any) => res.data)
        , catchError(super.serviceError));
  }

  getById(id: number) {
    return this.http
      .get(this.UrlService + "NotasFiscaisEnderecos/GetById/" + id)
      .pipe(map((res: any) => res.data)
        , catchError(super.serviceError));
  }

  addOrUpdate(form) {
    return this.http
      .post(this.UrlService + "NotasFiscaisEnderecos/PostNFeEnderecos/", form)
      .pipe(map((res: any) => res.data)
        , catchError(super.serviceError));
  }

  getByIdCombobox(id: number) {
    return this.http
      .get(this.UrlService + "NotasFiscaisEnderecos/GetByIdCombobox/" + id)
      .pipe(map((res: any) => res.data)
        , catchError(super.serviceError));
  }
}
